import {
  background,
  color,
  typography,
  space,
  flexbox,
  grid,
} from '@chakra-ui/system';
import { objectKeys, split } from '@chakra-ui/utils';

export const INNER_CELL_PROP_NAMES = objectKeys(
  Object.assign({}, background, color, typography, space, flexbox, grid),
);

export const getCellProps = (props: any) => {
  return split(props, INNER_CELL_PROP_NAMES as any);
};
